module.exports = __webpack_public_path__ + "img/right-arrow.28fbed0e.svg";